import {onMounted} from 'vue';
import router from '@/router';
import {authData, getLoggedUser} from '@/services/AuthService';

/**
 * Funkce aplikace podle instance – BE je posílá v profilu přihlášeného uživatele (api/auth/profile → features).
 * Dluhopisy jsou jen v IN Equity, v B.I.G. Invest SK a CZ se celé skrývají (menu, nástěnka, karta klienta,
 * reporting, administrace, kalkulačka onboardingu).
 * Starší BE příznak neposílá – pak se dluhopisy berou jako zapnuté (dosavadní chování).
 */
export function bondsEnabled(user) {
    return user?.features?.bonds !== false;
}

/** Dluhopisy pro přihlášeného uživatele (počká na načtení profilu). */
export async function areBondsEnabled() {
    return bondsEnabled(await getLoggedUser());
}

/**
 * Stránka dluhopisů v instanci bez dluhopisů přesměruje na nástěnku (např. přímý odkaz nebo uložená adresa).
 * Kontrola je ve stránce, ne v routeru – AuthService router importuje a import opačným směrem by byl kruhový.
 */
export function useBondsPageGuard() {
    onMounted(async () => {
        if (!(await areBondsEnabled())) {
            router.replace({name: 'Dashboard'});
        }
    });
}

/** Role, které detail dluhopisu načítají z API poradce (BE AdvisorBondController::get – poradci i administrace). */
const ADVISOR_DETAIL_ROLES = ['INTERMEDIARY', 'INTERMEDIARY_ADMIN', 'INTERMEDIARY_LEADER', 'INTERMEDIARY_MANAGER', 'ADMIN', 'SUPERADMIN', 'BACK_OFFICE'];

/**
 * Kdo v kalkulačce onboardingu uvidí detail dluhopisu a z jakého API: klient (SO) z klientského,
 * poradce i administrace (ASO) z API poradce. Ostatní role detail nedostanou.
 *
 * @returns {{canShow: boolean, advisor: boolean}}
 */
export function bondDetailViewer() {
    const role = authData.loggedUser?.role;
    const advisor = ADVISOR_DETAIL_ROLES.includes(role);
    return {canShow: advisor || role === 'CLIENT', advisor};
}
